import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Content from "../../../components/layout/Content";
import {useDispatch, useSelector} from "react-redux";
import WriteOffList from "./WriteOffList";
import { fetchWriteOffFormReasons } from "../../../action/reasons";
import ErrorContainer from "../../../components/utils/ErrorContainer";
import HeadMobileActionMenu from "../../../components/utils/HeadMobileActionMenu";
import { fetchWriteoffs } from '../../../action/writeoff';
import { fetchFilials } from '../../../action/handbook';
import { isEmpty } from 'lodash';
import { fetchSettings } from '../../../action/app';
import swal from 'sweetalert';

const WriteOff = ({ history }) => {
    const dispatch = useDispatch();
    const settings = useSelector(state => state.settings.init);

    const onRefresh = () => {
        dispatch(fetchWriteoffs());
        dispatch(fetchFilials(null, true))
        dispatch(fetchWriteOffFormReasons(false, true));
        dispatch(fetchSettings());
    };

    useEffect(() => {
        if (isEmpty(settings)) dispatch(fetchSettings());
    }, [settings, dispatch]);

    const openForm = () => {
        if (!isEmpty(settings) && !settings.enableConsumption) {
            return swal({
                title: 'Создание списания невозможно',
                text: '"Списание сырья" отключено',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        } else {
            history.push('/accounting/writeoff/form');
        }
    }

    const actionsMobile = [
        { name: 'Добавить списание', icon: 'flaticon2-plus', action: () => openForm() },
    ];

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Списания</h3>
                    </div>
                    <div className="kt-subheader__toolbar">
                        {window.innerWidth > 1024 && (
                            <button
                                className="btn btn-success btn-icon-sm"
                                onClick={openForm}>
                                Добавить списание
                            </button>
                        )}
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Content>
            {renderSubHeader()}
            <HeadMobileActionMenu actions={actionsMobile} />
            <ErrorContainer field='writeOffs' hasCloseButton={true} style={{ margin: 25 }}/>
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <WriteOffList/>
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default withRouter(WriteOff);
